import { BrowserRouter, Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import RequestCOAPage from './pages/RequestCOAPage'
import SearchCOAPage from './pages/SearchCOAPage'
import QueryPage from './pages/QueryPage'
import AboutPage from './pages/AboutPage'
import ContactPage from './pages/ContactPage'
import NotFoundPage from './pages/NotFoundPage'
import Header from './components/Header'
import Footer from './components/Footer'
import './App.css'

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <Header />
        <main>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/request" element={<RequestCOAPage />} />
          <Route path="/search" element={<SearchCOAPage />} />
          <Route path="/query" element={<QueryPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
    </BrowserRouter>
  )
}

export default App